module.exports = __webpack_public_path__ + "img/europapress.6b230d5c.svg";